import React, { useMemo, useState } from "react";
import styles from "../PreviewV3.module.css";
import JSAPreview from "../../JSAPreview";
import v2Styles from "../../../../../v2Styles.module.css";
import JSASectionActions from "./JSASectionActions";
import useJsaSectionState from "./useJsaSectionState";
import { decorateActivitiesWithRiskColors } from "./jsaSectionUtils";

export default function JSASection({ sectionData, displayName, sectionNumber, targetId, swmsData, approvalStatus, jobId, swmsId, onClose, onJsaActivitiesChange }) {
  const safeSectionData = sectionData || {};
  const activities = safeSectionData.activities || [];

  const consequences = swmsData && swmsData.meta && Array.isArray(swmsData.meta.consequences)
    ? [...swmsData.meta.consequences].sort((a, b) => Number(a.consequence_order) - Number(b.consequence_order))
    : [];

  const likelihoods = swmsData && swmsData.meta && Array.isArray(swmsData.meta.likelihoods)
    ? [...swmsData.meta.likelihoods].sort((a, b) => Number(a.likelihood_order) - Number(b.likelihood_order))
    : [];

  const risks = swmsData && swmsData.meta && swmsData.meta.risk_ratings && Array.isArray(swmsData.meta.risk_ratings.risk_rating_items)
    ? [...swmsData.meta.risk_ratings.risk_rating_items].sort((a, b) => Number(a.rating_order) - Number(b.rating_order))
    : [];

  const [jsaHovered, setJsaHovered] = useState(false);
  const {
    activitiesData,
    compKey,
    isJSASectionDisabled,
    jsaV2Updated,
    onActivityAdd,
    onCancelChanges,
    onDrop,
    onJSADataAdd,
    onJSADataDelete,
    onMoveActivity,
    onMoveRouter,
    onRiskSave,
    onSaveJSA,
    onV2ActUpdate,
    updating,
  } = useJsaSectionState({
    activities,
    swmsData,
    approvalStatus,
    jobId,
    swmsId,
    onClose,
    onJsaActivitiesChange,
  });

  const enrichedActivities = useMemo(() => decorateActivitiesWithRiskColors(activitiesData, risks), [activitiesData, risks]);

  return (
    <div className={styles.PreviewSectionBlock} id={targetId} style={{ scrollMarginTop: "140px" }} onMouseEnter={() => setJsaHovered(true)} onMouseLeave={() => setJsaHovered(false)}>
      <div className={styles.PreviewSectionHead}>
        <span className={styles.PreviewSectionNum}>{sectionNumber}</span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}>
        <div className={styles.JSALegend}>
          {risks.map((risk, index) => (
            <div key={index} className={styles.JSALegendItem} style={{ backgroundColor: risk.risk_colours || "" }}>
              {risk.risk_ratings} {risk.risk_rating_low_value} - {risk.risk_rating_high_value}
            </div>
          ))}
        </div>
        <table className={styles.JSATable}>
          <colgroup>
            <col width="40px" />
            <col width="" />
            <col width="" />
            <col width="" />
            <col width="34px" />
            <col width="27%" />
            <col width="34px" />
            <col width="12%" />
          </colgroup>
          <thead>
            <tr>
              <th className={styles.Centered}>Step</th>
              <th>Task Name</th>
              <th>Hazard & Risk</th>
              <th>Consequences</th>
              <th className={styles.Centered}>IR</th>
              <th>Control Measures</th>
              <th className={styles.Centered}>RR</th>
              <th>Person in Control</th>
            </tr>
          </thead>
          <JSAPreview
            key={compKey}
            activities={enrichedActivities}
            likelihoods={likelihoods}
            consequences={consequences}
            riskRatings={risks}
            isDisabled={isJSASectionDisabled}
            onUpdate={onV2ActUpdate}
            onDelete={onJSADataDelete}
            onAdd={onJSADataAdd}
            onMoveActivity={onMoveActivity}
            onMove={onMoveRouter}
            onDrop={onDrop}
            onRiskSave={onRiskSave}
          />
        </table>
        {jsaHovered && !isJSASectionDisabled ? (
          <div className="position-relative p-0" style={{ border: "0px !important" }}>
            <div className="position-absolute" style={{ bottom: "50%", right: "-10px", transform: "translateY(50%)", background: "#fff", borderRadius: "50%" }}>
              <button onClick={onActivityAdd} className={`${v2Styles.LighterButton} ${v2Styles.SmallButton} p-1`} style={{ padding: "4px !important", transition: "none" }} type="button">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ height: "18px", width: "18px" }} fill="#999">
                  <path d="M352 128C352 110.3 337.7 96 320 96C302.3 96 288 110.3 288 128L288 288L128 288C110.3 288 96 302.3 96 320C96 337.7 110.3 352 128 352L288 352L288 512C288 529.7 302.3 544 320 544C337.7 544 352 529.7 352 512L352 352L512 352C529.7 352 544 337.7 544 320C544 302.3 529.7 288 512 288L352 288L352 128z" />
                </svg>
              </button>
            </div>
          </div>
        ) : null}
        <JSASectionActions visible={jsaV2Updated && !isJSASectionDisabled} updating={updating} onCancelChanges={onCancelChanges} onSaveJSA={onSaveJSA} />
      </div>
    </div>
  )
}